var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgMapMarker(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M16 7c3.24 0 5.867 2.636 5.867 5.836a5.713 5.713 0 01-1.087 3.36c-.02.025-.046.067-1.74 2.697 1.84.28 4.96 1.11 4.96 2.943C24 23.929 19.84 25 16 25c-2.054 0-3.993-.285-5.46-.803C8.44 23.455 8 22.504 8 21.836c0-1.832 3.123-2.664 4.96-2.943l-1.718-2.666a5.744 5.744 0 01-1.109-3.391C10.133 9.63 12.77 7 16 7zm2.409 12.87l-1.96 3.04a.535.535 0 01-.899 0l-1.959-3.04c-3.117.384-4.524 1.368-4.524 1.966 0 .89 2.738 2.11 6.933 2.11 4.22 0 6.933-1.228 6.933-2.11 0-.598-1.407-1.582-4.524-1.965zM16 8.056c-2.652 0-4.8 2.144-4.8 4.78a4.696 4.696 0 00.933 2.812L16 21.646c4.14-6.424 3.872-6.012 3.924-6.08a4.672 4.672 0 00.876-2.73c0-2.636-2.153-4.781-4.8-4.781zm0 2.144c1.47 0 2.667 1.183 2.667 2.637S17.47 15.473 16 15.473c-1.47 0-2.667-1.183-2.667-2.637S14.53 10.199 16 10.199zm0 1.055c-.882 0-1.6.71-1.6 1.582 0 .872.718 1.582 1.6 1.582.882 0 1.6-.71 1.6-1.582 0-.872-.718-1.582-1.6-1.582z"
  }));
}

export default SvgMapMarker;